<template>
	<div
		class="color-indicator"
		ref="indicatorDiv"
		@mouseenter="onMouseEnter"
		@mouseleave="onMouseLeave"
		@focus="onMouseEnter"
		@blur="onMouseLeave"
    	:tabindex="tooltipText ? 0 : null"
	>
		<div
			v-if="indicatorValue"
			class="color-indicator__circle"
			:data-bg="dataBg"
		>
			<span class="color-indicator__value" :data-color="dataColor">
				{{ indicatorValue }}
			</span>
		</div>
		<div
			v-else
			class="color-indicator__square"
			ref="indicatorBgSquare"
			:data-bg="dataBg"
			:style="squareStyle"
		>
			<i
				:class="['color-indicator__icon icon', iconClassName]"
				ref="indicatorIcon"
				:data-color="dataColor"
				:style="iconStyle"
			/>
		</div>
		<Tooltip :visible="tooltipVisible" trackedRefName="indicatorDiv">
			{{ tooltipText }}
		</Tooltip>
	</div>
</template>

<script>
import Tooltip from '@/components/shells/tooltip/tooltip.vue';

export default {
	name: 'UIColorIndicator',
	components: {
		Tooltip
	},
	data() {
		return {
			tooltipActive: false
		};
	},
	props: {
		backgroundColor: {
			type: String
		},
		color: {
			type: String
		},
		iconClassName: {
			type: String,
			default: ''
		},
		tooltipText: {
			type: String
		},
		width: {
			type: [String, Number],
			default: null
		},
		height: {
			type: [String, Number],
			default: null
		},
		fontSize: {
			type: [String, Number],
			default: null
		},
		dataBg: {
			type: String,
			default: null
		},
		dataColor: {
			type: String,
			default: null
		},
		indicatorValue: {
			type: [String, Number],
			default: null
		}
	},
	computed: {
		tooltipVisible() {
			let result = false;

			result = this.tooltipText && this.tooltipActive;

			return result;
		},
		squareStyle() {
			if (
				typeof this.width === 'number' &&
				typeof this.height === 'number'
			) {
				return {
					width: `${this.width}px`,
					height: `${this.height}px`
				};
			} else {
				return {
					width: this.width,
					height: this.height
				};
			}
		},
		iconStyle() {
			if (typeof this.fontSize === 'number') {
				return {
					'font-size': `${this.fontSize}px`
				};
			} else {
				return {
					'font-size': this.fontSize
				};
			}
		}
	},
	methods: {
		onMouseEnter() {
			this.tooltipActive = true;
		},
		onMouseLeave() {
			this.tooltipActive = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.color-indicator {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-radius: $border-radius;
	background: var(--ui-indictor-bg-light);

	&:focus{
		outline: $focus-width $focus-style var(--neutral-3);
	}

	&__square {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 22px;
		height: 22px;
		margin: $gutter-xs;
		border-radius: $border-radius;
	}

	&__circle {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border-radius: 12px;
		border: 1px solid $ui-accessible-need;
	}

	&__value {
		font-size: $txt-supporting-font-size;
		line-height: 12px;
		min-width: 16px;
		height: 16px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 0 $padding-xs;
	}

	&__icon {
		font-size: 16px;
		padding: $padding-xs;
		border-radius: $border-radius;
	}
}
</style>
